const ConstData = {
    // AWS
    AWS_BUCKET: process.env.MIX_AWS_BUCKET,
    AWS_S3_URL_HOST: process.env.MIX_AWS_S3_URL_HOST,

    VAPID_PUBLIC_KEY: process.env.MIX_VAPID_PUBLIC_KEY,

    max_file_size: 5000000,
    file_size_error: '選択した画像サイズが大きすぎます。5MB以下にしてください。',
    type: '',

    index: 0,

    utility_again: false,
}

export default ConstData
